import { HeroBlock } from "@foodpilot/foods";
import { Box } from "@mui/material";

import { useHeroSection } from "./hooks/useHeroSection";
import { HeroSectionProps } from "./types";

export const HeroSection = (props: HeroSectionProps) => {
    const { title, subtitle, description, imageUrl, ctaLabel, ctaLink } = props;
    const { callToActionProps, descriptionStyles } = useHeroSection({
        title,
        subtitle,
        description,
        imageUrl,
        ctaLabel,
        ctaLink,
    });

    return (
        <HeroBlock
            title={title}
            subtitle={subtitle}
            description={
                description ?
                    <Box sx={descriptionStyles} dangerouslySetInnerHTML={{ __html: description }} />
                :   undefined
            }
            callToAction={callToActionProps}
            imageUrl={imageUrl}
        />
    );
};
